module.exports = __webpack_public_path__ + "static/img/logo-transparent.d12c9fcc.png";